// Translations for 8 languages
export const T = {
  fr: {
    // Home
    take_photo: 'PRENDRE UNE PHOTO',
    take_photo_sub: "Ouvrir l'appareil photo",
    import_photo: 'IMPORTER UNE PHOTO',
    import_photo_sub: 'Depuis la galerie',
    my_projects: 'MES PROJETS',
    my_projects_sub: 'Reprendre un projet',
    demo: 'Démo',
    demo_sub: 'Tester sans photo',
    admin: 'Admin',
    admin_sub: 'Clés API',

    // Objects
    store: 'Store banne',
    pergola: 'Pergola',

    // Params
    width: 'Largeur',
    height: 'Hauteur',
    depth: 'Profondeur',
    toile: 'Toile',
    structure: 'Structure',
    liner: 'Liner',
    color: 'Couleur',
    led: 'LED',
    descent: 'Descente',
    panels: 'Panneaux',
    handle: 'Poignée',
    left: 'Gauche',
    right: 'Droite',
    feet: 'Pieds',
    screens: 'Screens',
    sections: 'Sections',
    windows: 'Hublots',

    // Actions
    cancel: 'Annuler',
    validate: 'Valider',
    validate_simulate: 'Valider et simuler',
    save: 'Sauvegarder',
    share: 'Partager',
    download: 'Télécharger',
    delete: 'Supprimer',
    rename: 'Renommer',
    resume: 'Reprendre',

    // Measure
    measure_hint: 'Donnez une dimension horizontale avec 2 taps',
    tap1: 'Tap 1 — point de départ',
    tap2: 'Tap 2 — point d\'arrivée',
    enter_cm: 'Entrez la distance en centimètres',
    confirm: 'Confirmer',
    restart: 'Recommencer',
    skip: 'Passer',
    no_measure_warning: 'Aucune mesure fournie — dimensions estimées par l\'IA',

    // Save
    save_as: 'Enregistrer sous',
    project_name: 'Nom du projet',
    name_required: 'Nom requis',
    project_saved: 'Projet sauvegardé',
    share_project: 'Partager le projet',
    back_to_project: 'Retour au projet',

    // Auth
    login: 'Connexion',
    logout: 'Déconnexion',
    register: 'Inscription',
    email: 'Email',
    password: 'Mot de passe',
    name: 'Nom',


    // Plans
    free_plan: 'Gratuit',
    monthly_plan: 'Mensuel',
    annual_plan: 'Annuel',
    credits: 'Crédits',
    subscribe: "S'abonner",
    credits_remaining: 'crédits restants',

    // AI
    ia_loading: 'Génération IA en cours...',
    ia_loading_wait: 'Veuillez patienter',
    ia_cancel: 'Annuler',
    no_credits: 'Plus de crédits disponibles',

    // Language
    language: 'Langue',

    // Projects
    no_projects: 'Aucun projet sauvegardé',

    // General
    back: 'Retour',
    close: 'Fermer',
    settings: 'Paramètres',
    choose_object: 'Choisissez un objet',

    // AI History
    ai_history: 'Historique IA',
    generations: 'génération(s)',
    no_history: 'Aucune génération',
    generate_first: 'Générez votre première image IA',
    select_image: 'Sélectionnez une image',
    use_image: 'Utiliser cette image',
    image_loaded: 'Image chargée',
  },

  en: {
    take_photo: 'TAKE A PHOTO',
    take_photo_sub: 'Open camera',
    import_photo: 'IMPORT A PHOTO',
    import_photo_sub: 'From gallery',
    my_projects: 'MY PROJECTS',
    my_projects_sub: 'Resume a project',
    demo: 'Demo',
    demo_sub: 'Test without photo',
    admin: 'Admin',
    admin_sub: 'API keys',
    store: 'Awning',
    pergola: 'Pergola',
    width: 'Width',
    height: 'Height',
    depth: 'Depth',
    toile: 'Fabric',
    structure: 'Structure',
    liner: 'Liner',
    color: 'Color',
    led: 'LED',
    descent: 'Descent',
    panels: 'Panels',
    handle: 'Handle',
    left: 'Left',
    right: 'Right',
    feet: 'Feet',
    screens: 'Screens',
    sections: 'Sections',
    windows: 'Windows',
    cancel: 'Cancel',
    validate: 'Validate',
    validate_simulate: 'Validate and simulate',
    save: 'Save',
    share: 'Share',
    download: 'Download',
    delete: 'Delete',
    rename: 'Rename',
    resume: 'Resume',
    measure_hint: 'Give a horizontal dimension with 2 taps',
    tap1: 'Tap 1 — start point',
    tap2: 'Tap 2 — end point',
    enter_cm: 'Enter the distance in centimeters',
    confirm: 'Confirm',
    restart: 'Restart',
    skip: 'Skip',
    no_measure_warning: 'No measure provided — dimensions estimated by AI',
    save_as: 'Save as',
    project_name: 'Project name',
    name_required: 'Name required',
    project_saved: 'Project saved',
    share_project: 'Share project',
    back_to_project: 'Back to project',
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    name: 'Name',

    free_plan: 'Free',
    monthly_plan: 'Monthly',
    annual_plan: 'Annual',
    credits: 'Credits',
    subscribe: 'Subscribe',
    credits_remaining: 'credits remaining',
    ia_loading: 'AI generation in progress...',
    ia_loading_wait: 'Please wait',
    ia_cancel: 'Cancel',
    no_credits: 'No credits available',
    language: 'Language',
    no_projects: 'No saved projects',
    back: 'Back',
    close: 'Close',
    settings: 'Settings',
    choose_object: 'Choose an object',

    // AI History
    ai_history: 'AI History',
    generations: 'generation(s)',
    no_history: 'No generations',
    generate_first: 'Generate your first AI image',
    select_image: 'Select an image',
    use_image: 'Use this image',
    image_loaded: 'Image loaded',
  },

  de: {
    take_photo: 'FOTO AUFNEHMEN',
    take_photo_sub: 'Kamera öffnen',
    import_photo: 'FOTO IMPORTIEREN',
    import_photo_sub: 'Aus der Galerie',
    my_projects: 'MEINE PROJEKTE',
    my_projects_sub: 'Projekt fortsetzen',
    demo: 'Demo',
    demo_sub: 'Ohne Foto testen',
    admin: 'Admin',
    admin_sub: 'API-Schlüssel',
    store: 'Markise',
    pergola: 'Pergola',
    width: 'Breite',
    height: 'Höhe',
    depth: 'Tiefe',
    toile: 'Stoff',
    structure: 'Struktur',
    liner: 'Folie',
    color: 'Farbe',
    led: 'LED',
    descent: 'Abstieg',
    panels: 'Paneele',
    handle: 'Griff',
    left: 'Links',
    right: 'Rechts',
    feet: 'Füße',
    screens: 'Screens',
    sections: 'Sektionen',
    windows: 'Fenster',
    cancel: 'Abbrechen',
    validate: 'Bestätigen',
    validate_simulate: 'Bestätigen und simulieren',
    save: 'Speichern',
    share: 'Teilen',
    download: 'Herunterladen',
    delete: 'Löschen',
    rename: 'Umbenennen',
    resume: 'Fortsetzen',
    measure_hint: 'Geben Sie eine horizontale Abmessung mit 2 Taps',
    tap1: 'Tap 1 — Startpunkt',
    tap2: 'Tap 2 — Endpunkt',
    enter_cm: 'Geben Sie die Entfernung in Zentimetern ein',
    confirm: 'Bestätigen',
    restart: 'Neustart',
    skip: 'Überspringen',
    no_measure_warning: 'Keine Messung bereitgestellt — Abmessungen von KI geschätzt',
    save_as: 'Speichern unter',
    project_name: 'Projektname',
    name_required: 'Name erforderlich',
    project_saved: 'Projekt gespeichert',
    share_project: 'Projekt teilen',
    back_to_project: 'Zurück zum Projekt',
    login: 'Anmelden',
    logout: 'Abmelden',
    register: 'Registrieren',
    email: 'E-Mail',
    password: 'Passwort',
    name: 'Name',

    free_plan: 'Kostenlos',
    monthly_plan: 'Monatlich',
    annual_plan: 'Jährlich',
    credits: 'Credits',
    subscribe: 'Abonnieren',
    credits_remaining: 'Credits übrig',
    ia_loading: 'KI-Generierung läuft...',
    ia_loading_wait: 'Bitte warten',
    ia_cancel: 'Abbrechen',
    no_credits: 'Keine Credits verfügbar',
    language: 'Sprache',
    no_projects: 'Keine gespeicherten Projekte',
    back: 'Zurück',
    close: 'Schließen',
    settings: 'Einstellungen',
    choose_object: 'Objekt auswählen',
  },

  es: {
    take_photo: 'TOMAR UNA FOTO',
    take_photo_sub: 'Abrir cámara',
    import_photo: 'IMPORTAR UNA FOTO',
    import_photo_sub: 'Desde la galería',
    my_projects: 'MIS PROYECTOS',
    my_projects_sub: 'Continuar proyecto',
    demo: 'Demo',
    demo_sub: 'Probar sin foto',
    admin: 'Admin',
    admin_sub: 'Claves API',
    store: 'Toldo',
    pergola: 'Pérgola',
    width: 'Ancho',
    height: 'Alto',
    depth: 'Profundidad',
    toile: 'Lona',
    structure: 'Estructura',
    liner: 'Liner',
    color: 'Color',
    led: 'LED',
    descent: 'Descenso',
    panels: 'Paneles',
    handle: 'Manija',
    left: 'Izquierda',
    right: 'Derecha',
    feet: 'Pies',
    screens: 'Pantallas',
    sections: 'Secciones',
    windows: 'Ventanas',
    cancel: 'Cancelar',
    validate: 'Validar',
    validate_simulate: 'Validar y simular',
    save: 'Guardar',
    share: 'Compartir',
    download: 'Descargar',
    delete: 'Eliminar',
    rename: 'Renombrar',
    resume: 'Continuar',
    measure_hint: 'Da una dimensión horizontal con 2 toques',
    tap1: 'Toque 1 — punto de inicio',
    tap2: 'Toque 2 — punto final',
    enter_cm: 'Ingrese la distancia en centímetros',
    confirm: 'Confirmar',
    restart: 'Reiniciar',
    skip: 'Omitir',
    no_measure_warning: 'Sin medida proporcionada — dimensiones estimadas por IA',
    save_as: 'Guardar como',
    project_name: 'Nombre del proyecto',
    name_required: 'Nombre requerido',
    project_saved: 'Proyecto guardado',
    share_project: 'Compartir proyecto',
    back_to_project: 'Volver al proyecto',
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    register: 'Registrarse',
    email: 'Correo',
    password: 'Contraseña',
    name: 'Nombre',

    free_plan: 'Gratis',
    monthly_plan: 'Mensual',
    annual_plan: 'Anual',
    credits: 'Créditos',
    subscribe: 'Suscribirse',
    credits_remaining: 'créditos restantes',
    ia_loading: 'Generación IA en progreso...',
    ia_loading_wait: 'Por favor espere',
    ia_cancel: 'Cancelar',
    no_credits: 'Sin créditos disponibles',
    language: 'Idioma',
    no_projects: 'Sin proyectos guardados',
    back: 'Atrás',
    close: 'Cerrar',
    settings: 'Ajustes',
    choose_object: 'Elegir objeto',
  },

  it: {
    take_photo: 'SCATTA UNA FOTO',
    take_photo_sub: 'Apri fotocamera',
    import_photo: 'IMPORTA UNA FOTO',
    import_photo_sub: 'Dalla galleria',
    my_projects: 'I MIEI PROGETTI',
    my_projects_sub: 'Riprendi un progetto',
    demo: 'Demo',
    demo_sub: 'Testa senza foto',
    admin: 'Admin',
    admin_sub: 'Chiavi API',
    store: 'Tenda',
    pergola: 'Pergola',
    width: 'Larghezza',
    height: 'Altezza',
    depth: 'Profondità',
    toile: 'Tela',
    structure: 'Struttura',
    liner: 'Liner',
    color: 'Colore',
    led: 'LED',
    descent: 'Discesa',
    panels: 'Pannelli',
    handle: 'Maniglia',
    left: 'Sinistra',
    right: 'Destra',
    feet: 'Piedi',
    screens: 'Schermi',
    sections: 'Sezioni',
    windows: 'Finestre',
    cancel: 'Annulla',
    validate: 'Convalida',
    validate_simulate: 'Convalida e simula',
    save: 'Salva',
    share: 'Condividi',
    download: 'Scarica',
    delete: 'Elimina',
    rename: 'Rinomina',
    resume: 'Riprendi',
    measure_hint: 'Dai una dimensione orizzontale con 2 tocchi',
    tap1: 'Tocco 1 — punto di partenza',
    tap2: 'Tocco 2 — punto finale',
    enter_cm: 'Inserisci la distanza in centimetri',
    confirm: 'Conferma',
    restart: 'Ricomincia',
    skip: 'Salta',
    no_measure_warning: 'Nessuna misura fornita — dimensioni stimate da IA',
    save_as: 'Salva come',
    project_name: 'Nome progetto',
    name_required: 'Nome richiesto',
    project_saved: 'Progetto salvato',
    share_project: 'Condividi progetto',
    back_to_project: 'Torna al progetto',
    login: 'Accedi',
    logout: 'Esci',
    register: 'Registrati',
    email: 'Email',
    password: 'Password',
    name: 'Nome',

    free_plan: 'Gratuito',
    monthly_plan: 'Mensile',
    annual_plan: 'Annuale',
    credits: 'Crediti',
    subscribe: 'Iscriviti',
    credits_remaining: 'crediti rimanenti',
    ia_loading: 'Generazione IA in corso...',
    ia_loading_wait: 'Attendere prego',
    ia_cancel: 'Annulla',
    no_credits: 'Nessun credito disponibile',
    language: 'Lingua',
    no_projects: 'Nessun progetto salvato',
    back: 'Indietro',
    close: 'Chiudi',
    settings: 'Impostazioni',
    choose_object: 'Scegli un oggetto',
  },

  nl: {
    take_photo: 'MAAK EEN FOTO',
    take_photo_sub: 'Open camera',
    import_photo: 'IMPORTEER EEN FOTO',
    import_photo_sub: 'Uit galerie',
    my_projects: 'MIJN PROJECTEN',
    my_projects_sub: 'Hervat een project',
    demo: 'Demo',
    demo_sub: 'Test zonder foto',
    admin: 'Admin',
    admin_sub: 'API-sleutels',
    store: 'Zonnescherm',
    pergola: 'Pergola',
    width: 'Breedte',
    height: 'Hoogte',
    depth: 'Diepte',
    toile: 'Doek',
    structure: 'Structuur',
    liner: 'Liner',
    color: 'Kleur',
    led: 'LED',
    descent: 'Afdaling',
    panels: 'Panelen',
    handle: 'Handvat',
    left: 'Links',
    right: 'Rechts',
    feet: 'Voeten',
    screens: 'Schermen',
    sections: 'Secties',
    windows: 'Ramen',
    cancel: 'Annuleren',
    validate: 'Valideren',
    validate_simulate: 'Valideren en simuleren',
    save: 'Opslaan',
    share: 'Delen',
    download: 'Downloaden',
    delete: 'Verwijderen',
    rename: 'Hernoemen',
    resume: 'Hervatten',
    measure_hint: 'Geef een horizontale afmeting met 2 tikken',
    tap1: 'Tik 1 — startpunt',
    tap2: 'Tik 2 — eindpunt',
    enter_cm: 'Voer de afstand in centimeters in',
    confirm: 'Bevestigen',
    restart: 'Herstarten',
    skip: 'Overslaan',
    no_measure_warning: 'Geen meting verstrekt — afmetingen geschat door AI',
    save_as: 'Opslaan als',
    project_name: 'Projectnaam',
    name_required: 'Naam vereist',
    project_saved: 'Project opgeslagen',
    share_project: 'Project delen',
    back_to_project: 'Terug naar project',
    login: 'Inloggen',
    logout: 'Uitloggen',
    register: 'Registreren',
    email: 'E-mail',
    password: 'Wachtwoord',
    name: 'Naam',

    free_plan: 'Gratis',
    monthly_plan: 'Maandelijks',
    annual_plan: 'Jaarlijks',
    credits: 'Credits',
    subscribe: 'Abonneren',
    credits_remaining: 'credits over',
    ia_loading: 'AI-generatie bezig...',
    ia_loading_wait: 'Even geduld',
    ia_cancel: 'Annuleren',
    no_credits: 'Geen credits beschikbaar',
    language: 'Taal',
    no_projects: 'Geen opgeslagen projecten',
    back: 'Terug',
    close: 'Sluiten',
    settings: 'Instellingen',
    choose_object: 'Kies een object',
  },

  pt: {
    take_photo: 'TIRAR UMA FOTO',
    take_photo_sub: 'Abrir câmera',
    import_photo: 'IMPORTAR UMA FOTO',
    import_photo_sub: 'Da galeria',
    my_projects: 'MEUS PROJETOS',
    my_projects_sub: 'Retomar um projeto',
    demo: 'Demo',
    demo_sub: 'Testar sem foto',
    admin: 'Admin',
    admin_sub: 'Chaves API',
    store: 'Toldo',
    pergola: 'Pérgula',
    width: 'Largura',
    height: 'Altura',
    depth: 'Profundidade',
    toile: 'Tecido',
    structure: 'Estrutura',
    liner: 'Liner',
    color: 'Cor',
    led: 'LED',
    descent: 'Descida',
    panels: 'Painéis',
    handle: 'Puxador',
    left: 'Esquerda',
    right: 'Direita',
    feet: 'Pés',
    screens: 'Telas',
    sections: 'Seções',
    windows: 'Janelas',
    cancel: 'Cancelar',
    validate: 'Validar',
    validate_simulate: 'Validar e simular',
    save: 'Salvar',
    share: 'Compartilhar',
    download: 'Baixar',
    delete: 'Excluir',
    rename: 'Renomear',
    resume: 'Retomar',
    measure_hint: 'Dê uma dimensão horizontal com 2 toques',
    tap1: 'Toque 1 — ponto inicial',
    tap2: 'Toque 2 — ponto final',
    enter_cm: 'Insira a distância em centímetros',
    confirm: 'Confirmar',
    restart: 'Reiniciar',
    skip: 'Pular',
    no_measure_warning: 'Nenhuma medida fornecida — dimensões estimadas pela IA',
    save_as: 'Salvar como',
    project_name: 'Nome do projeto',
    name_required: 'Nome obrigatório',
    project_saved: 'Projeto salvo',
    share_project: 'Compartilhar projeto',
    back_to_project: 'Voltar ao projeto',
    login: 'Entrar',
    logout: 'Sair',
    register: 'Registrar',
    email: 'Email',
    password: 'Senha',
    name: 'Nome',

    free_plan: 'Grátis',
    monthly_plan: 'Mensal',
    annual_plan: 'Anual',
    credits: 'Créditos',
    subscribe: 'Assinar',
    credits_remaining: 'créditos restantes',
    ia_loading: 'Geração IA em andamento...',
    ia_loading_wait: 'Por favor aguarde',
    ia_cancel: 'Cancelar',
    no_credits: 'Sem créditos disponíveis',
    language: 'Idioma',
    no_projects: 'Nenhum projeto salvo',
    back: 'Voltar',
    close: 'Fechar',
    settings: 'Configurações',
    choose_object: 'Escolha um objeto',
  },

  sv: {
    take_photo: 'TA ETT FOTO',
    take_photo_sub: 'Öppna kamera',
    import_photo: 'IMPORTERA ETT FOTO',
    import_photo_sub: 'Från galleri',
    my_projects: 'MINA PROJEKT',
    my_projects_sub: 'Återuppta ett projekt',
    demo: 'Demo',
    demo_sub: 'Testa utan foto',
    admin: 'Admin',
    admin_sub: 'API-nycklar',
    store: 'Markis',
    pergola: 'Pergola',
    width: 'Bredd',
    height: 'Höjd',
    depth: 'Djup',
    toile: 'Tyg',
    structure: 'Struktur',
    liner: 'Liner',
    color: 'Färg',
    led: 'LED',
    descent: 'Nedgång',
    panels: 'Paneler',
    handle: 'Handtag',
    left: 'Vänster',
    right: 'Höger',
    feet: 'Fötter',
    screens: 'Skärmar',
    sections: 'Sektioner',
    windows: 'Fönster',
    cancel: 'Avbryt',
    validate: 'Validera',
    validate_simulate: 'Validera och simulera',
    save: 'Spara',
    share: 'Dela',
    download: 'Ladda ner',
    delete: 'Ta bort',
    rename: 'Byt namn',
    resume: 'Återuppta',
    measure_hint: 'Ge en horisontell dimension med 2 tryck',
    tap1: 'Tryck 1 — startpunkt',
    tap2: 'Tryck 2 — slutpunkt',
    enter_cm: 'Ange avståndet i centimeter',
    confirm: 'Bekräfta',
    restart: 'Starta om',
    skip: 'Hoppa över',
    no_measure_warning: 'Ingen mätning angiven — dimensioner uppskattade av AI',
    save_as: 'Spara som',
    project_name: 'Projektnamn',
    name_required: 'Namn krävs',
    project_saved: 'Projekt sparat',
    share_project: 'Dela projekt',
    back_to_project: 'Tillbaka till projekt',
    login: 'Logga in',
    logout: 'Logga ut',
    register: 'Registrera',
    email: 'E-post',
    password: 'Lösenord',
    name: 'Namn',

    free_plan: 'Gratis',
    monthly_plan: 'Månatlig',
    annual_plan: 'Årlig',
    credits: 'Krediter',
    subscribe: 'Prenumerera',
    credits_remaining: 'krediter kvar',
    ia_loading: 'AI-generering pågår...',
    ia_loading_wait: 'Vänligen vänta',
    ia_cancel: 'Avbryt',
    no_credits: 'Inga krediter tillgängliga',
    language: 'Språk',
    no_projects: 'Inga sparade projekt',
    back: 'Tillbaka',
    close: 'Stäng',
    settings: 'Inställningar',
    choose_object: 'Välj ett objekt',
  }
};

export const FLAGS = {
  fr: 'FR',
  en: 'EN',
  de: 'DE',
  es: 'ES',
  it: 'IT',
  nl: 'NL',
  pt: 'PT',
  sv: 'SV'
};

export const LANG_NAMES = {
  fr: 'Français',
  en: 'English',
  de: 'Deutsch',
  es: 'Español',
  it: 'Italiano',
  nl: 'Nederlands',
  pt: 'Português',
  sv: 'Svenska'
};

// Hook to get translations
export function useTranslation() {
  const { lang } = require('./store').useAppStore();
  return {
    t: (key) => T[lang]?.[key] || T.fr[key] || key,
    lang
  };
}
